import * as React from "react"

const FilterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29.334 8.66797H21.334"
      stroke="#008761"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99935 8.66797H2.66602"
      stroke="#008761"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3327 13.3333C15.91 13.3333 17.9993 11.244 17.9993 8.66667C17.9993 6.08934 15.91 4 13.3327 4C10.7554 4 8.66602 6.08934 8.66602 8.66667C8.66602 11.244 10.7554 13.3333 13.3327 13.3333Z"
      fill="#1BBD77"
      stroke="#008761"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.3333 23.332H24"
      stroke="#008761"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.666 23.332H2.66602"
      stroke="#008761"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6667 28.0013C21.244 28.0013 23.3333 25.912 23.3333 23.3346C23.3333 20.7573 21.244 18.668 18.6667 18.668C16.0893 18.668 14 20.7573 14 23.3346C14 25.912 16.0893 28.0013 18.6667 28.0013Z"
      fill="#1BBD77"
      stroke="#008761"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default FilterIcon
